// extracted by mini-css-extract-plugin
module.exports = {"SearchContainer":"Search_SearchContainer__KYNPX","expandSearch":"Search_expandSearch__z2LeE"};